module.exports = __webpack_public_path__ + "static/media/ionicons.326445b5.svg";